import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import Avatar from '@jimmyboys/liita-ui/dist/components/Avatar'
import Skeleton from '@jimmyboys/liita-ui/dist/components/Skeleton'

import BodyPart from 'components/BodyPart/BodyPart'
import ClinicalProgress from 'components/ClinicalProgress/ClinicalProgress'

import styles from './ClinicalProcessRow.module.sass'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

const ClinicalProcessRow = memo(
	(props) => {
		const { className, data, ...attributes } = props
		const statusClass = data.status?.icon

		const Tag = data.link ? Link : 'div'
		const to = data.link?.to

		return (
			<Tag {...attributes} className={styles['row']} to={to}>
				<span className={styles['icon-container']}>
					<BodyPart
						width='32px'
						height='32px'
						className={styles['icon']}
						code={data.info?.bodyPartCode}
						inline
					/>
				</span>
				<span className={styles['details']}>
					<div>
						<small>
							<strong>
								#{data.id} - {data.injured?.name || '-'}
							</strong>
						</small>
					</div>
					<div className={styles['sub-details']}>
						<span>
							<small>
								{data.$layout === 'small'
									? data.info?.admissionDate?.tinyDateFormat
									: data.info?.admissionDate?.shortDateFormat}
							</small>
						</span>
						<span>
							<small>
								{data.accident?.segment?.abbreviation}
							</small>
						</span>
						<span>
							<small>
								{
									data.insurancePolicy?.insuranceCompany
										.shortName
								}
							</small>
						</span>
						<span>
							<small>{data.provider?.name}</small>
						</span>
					</div>
				</span>
				<span
					className={
						data.$layout === 'small'
							? styles['status-label']
							: styles['progress-container']
					}
				>
					<ClinicalProgress
						info={data.info || {}}
						state={data.state || {}}
						status={statusClass}
						displaySmall={data.$layout === 'small'}
					/>
				</span>
				<span className={styles['avatar-containers']}>
					<span>
						<Avatar
							rounded
							className={styles['avatar']}
							user={data.clinicCoordinator || {}}
							width='26px'
							height='26px'
						/>
					</span>
				</span>
			</Tag>
		)
	},
	(prevProps, nextProps) =>
		prevProps.data.id === nextProps.data.id &&
		prevProps.data.$layout === nextProps.data.$layout &&
		prevProps.style.top === nextProps.style.top
)
ClinicalProcessRow.displayName = 'ClinicalProcessRow'
export default ClinicalProcessRow

export const ClinicalProcessRowSkeleton = (props) => {
	const { className, data, ...attributes } = props
	return (
		<div
			{...attributes}
			className={`${styles['row-skeleton']} ${className || ''}`}
		>
			<span className={styles['icon']}>
				<Skeleton className={styles['skeleton']} />
			</span>
			<span>
				<Skeleton
					className={`${styles['skeleton']} ${styles['small']}`}
				/>
				<Skeleton
					className={`${styles['skeleton']} ${styles['smaller']}`}
				/>
			</span>
			<span
				className={
					data.$layout === 'small'
						? styles['status-label']
						: styles['progress']
				}
			>
				<Skeleton className={styles['skeleton']} />
			</span>
			<span>
				<div className={styles['avatars-container']}>
					<Skeleton
						className={`${styles['skeleton']} ${styles['avatar']}`}
					/>
				</div>
			</span>
		</div>
	)
}

export const ClinicalProcessListHeader = (props) => {
	const { i18n } = useGlobal()
	return (
		<div className={`${styles['header']} ${props.className || ''}`}>
			<small
				className={`${styles['icon-container']} ${styles['align-center']}`}
			>
				<strong>{i18n`BP`}</strong>
			</small>
			<span className={styles['details']}>
				<div>
					<small>
						<strong>
							{i18n`ID`} - {i18n`Injured Name`}
						</strong>
					</small>
				</div>
				<div className={styles['sub-details']}>
					<span>
						<small>{i18n`Date`}</small>
					</span>
					<span>
						<small>{i18n`Proc. Type`}</small>
					</span>
					<span>
						<small>{i18n`Ins. Company`}</small>
					</span>
					<span>
						<small>{i18n`Provider`}</small>
					</span>
				</div>
			</span>
			<span
				className={`${
					props.$layout === 'small'
						? styles['status-label']
						: styles['progress-container']
				} ${styles['align-center']}`}
			>
				<small>
					<strong>
						{props.$layout === 'small' ? i18n`ST` : i18n`Progress`}
					</strong>
				</small>
			</span>
			<span>
				<small>
					<strong>{i18n`Clinical Coordinator`}</strong>
				</small>
			</span>
		</div>
	)
}
